import {
  bakeryDough,
  bakeryFilling,
  beverages,
  cereals,
  convenience,
  dairy,
  desserts,
  flavourBlends,
  fruitJam,
  meatFish,
  oilsFatsSpreads,
  soupsSaucesSeasonings,
} from '../dependencies/FoodNutrition';
import { FormulationAttributesOption } from './types';

export const storageOptions: FormulationAttributesOption[] = [
  {
    name: 'topics:formulation-attributes:options:availableStorage:ambient',
    value: 'ambient',
    applications: {
      '*|FoodNutrition': [],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableStorage:bakeryDryBlend',
    value: 'bakery-dry-blend',
    applications: {
      '*|FoodNutrition': [...bakeryDough],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableStorage:instantDryBlend',
    value: 'instant-dry-blend',
    applications: {
      '*|FoodNutrition': [...beverages, ...soupsSaucesSeasonings],
    },
  },
  {
    name: 'topics:formulation-attributes:options:availableStorage:frozen',
    value: 'frozen',
    applications: {
      '*|FoodNutrition': [
        ...bakeryDough,
        ...bakeryFilling,
        ...convenience,
        ...dairy,
        ...desserts,
        ...fruitJam,
        ...flavourBlends,
        ...meatFish,
        ...oilsFatsSpreads,
        ...soupsSaucesSeasonings,
      ],
    },
  },
  {
    name: 'topics:formulation-attributes:options:availableStorage:bestBefore',
    value: 'best-before',
    applications: {
      '*|FoodNutrition': [
        ...bakeryDough,
        ...cereals,
        ...convenience,
        ...dairy,
        ...desserts,
        ...meatFish,
        ...soupsSaucesSeasonings,
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableStorage:pasteurisation',
    value: 'pasteurisation',
    applications: {
      '*|FoodNutrition': [...bakeryFilling],
    },
  },
  {
    name: 'topics:formulation-attributes:options:availableStorage:chilled',
    value: 'chilled',
    applications: {
      '*|FoodNutrition': [
        ...bakeryFilling,
        ...beverages,
        ...convenience,
        ...dairy,
        ...desserts,
        ...flavourBlends,
        ...fruitJam,
        ...meatFish,
        ...oilsFatsSpreads,
        ...soupsSaucesSeasonings,
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableStorage:bakeStability',
    value: 'bakeStability',
    applications: {
      '*|FoodNutrition': [
        ...convenience,
        ...meatFish,
        ...soupsSaucesSeasonings,
      ],
    },
  },
];
